import { Ng2StateDeclaration, StatesModule } from '@uirouter/angular';
import { FiChecklist2ScheduleListComponent } from '../../shared/checklist/schedule/schedule-list/schedule-list.component';
import { FiChecklist2ScheduleEditComponent } from '../../shared/checklist/schedule/schedule-edit/schedule-edit.component';
import { FiStateService } from '../../shared/fi-state-proxy/fi-state.proxy.service';
import { Transition } from '@uirouter/core';
import { FiChecklist2ScheduleFactoryService } from '../../shared/checklist/schedule/services/fi-checklist2-schedule-factory.service';
import { FiChecklist2ScheduleService } from '../../shared/checklist/schedule/services/fi-checklist2-schedule.service';
import { coerceNumberProperty } from '@angular/cdk/coercion';
import { FiChecklist2Service } from '../../shared/checklist/fi-checklist2.service';
import { AccessRightService } from '../../shared/fi-shared-services';
import { ObjectTypes } from '../../shared/types';
import { FiStateNames } from '../../shared/fi-state-proxy/fi-state-names';
import { FiAbstractStateComponent } from '../../shared/fi-state-proxy/fi-abstract-state.component';
import { FiChatHelperService } from '@fi-shared/fi-chat/fi-chat-helper.service';
import { ChecklistV2Edit_isChatAvailable } from '@fi-app/checklist/checklist-v2/checklist-v2.states';
import { checklistScheduleIdsResolveFn } from '@fi-app/checklist/checklist-v2/checklist-v2-schedule-states';
import { ChecklistV2AuditEdit_savedQuickSelectionFiltersResolveFn } from '@fi-app/checklist/checklist-v2/checklist-v2-audit.states';

const auditMode = true;

const ChecklistV2AuditScheduleState: Ng2StateDeclaration = {
    name: FiStateNames.ChecklistV2Audit.Schedule._name,
    url: '/Schedule',
    abstract: true,
    component: FiAbstractStateComponent,
};

const ChecklistV2AuditScheduleListState: Ng2StateDeclaration = {
    name: FiStateNames.ChecklistV2Audit.Schedule.List,
    url: '/?:filterType&:sortColumn&:sortDirection&:offset',
    params: {
        checklistScheduleIds: null,
    },
    component: FiChecklist2ScheduleListComponent,
    reloadOnSearch: false,
    resolve: {
        checklistScheduleIds: checklistScheduleIdsResolveFn,
        auditMode: [() => auditMode],
    },
};

const lightWeightChecklistsResolveFn = [
    FiChecklist2Service,
    (fiChecklist2Service: FiChecklist2Service) => fiChecklist2Service.getLightWeightChecklists(auditMode),
];

const accessRightFilterCollectionResolveFn = [
    AccessRightService,
    (accessRightService: AccessRightService) => {
        return accessRightService.getAccessRightsForPublicationByObjectType(ObjectTypes.Checklist2AuditSchedule);
    },
];

const ChecklistV2AuditScheduleAddState: Ng2StateDeclaration = {
    name: FiStateNames.ChecklistV2Audit.Schedule.Add,
    url: '/Add',
    params: {
        checklistSchedule: null,
    },
    views: {
        '@Module': {
            component: FiChecklist2ScheduleEditComponent,
        },
    },
    resolve: {
        checklistSchedule: [
            FiStateService,
            Transition,
            FiChecklist2ScheduleFactoryService,
            (
                fiStateService: FiStateService,
                tr: Transition,
                fiChecklist2ScheduleFactoryService: FiChecklist2ScheduleFactoryService,
            ) => {
                const checkListSchedule =
                    fiStateService.getParams(tr).checklistSchedule ??
                    fiChecklist2ScheduleFactoryService.getChecklistScheduleInstance(auditMode);
                return checkListSchedule;
            },
        ],
        lightWeightChecklists: lightWeightChecklistsResolveFn,
        accessRightFilterCollection: accessRightFilterCollectionResolveFn,
        savedQuickSelectionFilters: [AccessRightService, ChecklistV2AuditEdit_savedQuickSelectionFiltersResolveFn],
        auditMode: [() => auditMode],
        isChatAvailable: [FiChatHelperService, ChecklistV2Edit_isChatAvailable],
    },
};

const ChecklistV2AuditScheduleEditState: Ng2StateDeclaration = {
    name: FiStateNames.ChecklistV2Audit.Schedule.Edit,
    url: '/{id:[0-9]+}/Edit',
    views: {
        '@Module': {
            component: FiChecklist2ScheduleEditComponent,
        },
    },
    resolve: {
        checklistSchedule: [
            FiStateService,
            Transition,
            FiChecklist2ScheduleService,
            (
                fiStateService: FiStateService,
                tr: Transition,
                fiChecklist2ScheduleService: FiChecklist2ScheduleService,
            ) => {
                const scheduleId = coerceNumberProperty(fiStateService.getParams(tr).id);
                return fiChecklist2ScheduleService.getChecklistSchedule(scheduleId, auditMode);
            },
        ],
        lightWeightChecklists: lightWeightChecklistsResolveFn,
        accessRightFilterCollection: accessRightFilterCollectionResolveFn,
        savedQuickSelectionFilters: [AccessRightService, ChecklistV2AuditEdit_savedQuickSelectionFiltersResolveFn],
        auditMode: [() => auditMode],
        isChatAvailable: [FiChatHelperService, ChecklistV2Edit_isChatAvailable],
    },
};

export const ChecklistV2AuditScheduleStates: StatesModule = {
    states: [
        ChecklistV2AuditScheduleState,
        ChecklistV2AuditScheduleListState,
        ChecklistV2AuditScheduleAddState,
        ChecklistV2AuditScheduleEditState,
    ],
};
